import { render, staticRenderFns } from "./UiLayout.vue?vue&type=template&id=32872c45&scoped=true"
import script from "./UiLayout.vue?vue&type=script&lang=js"
export * from "./UiLayout.vue?vue&type=script&lang=js"
import style0 from "./UiLayout.vue?vue&type=style&index=0&id=32872c45&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32872c45",
  null
  
)

export default component.exports